import "core-js/modules/es.array.push.js";
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { showLoadingToast, closeToast } from "vant";
import { getLeaveList } from "@/api/leave";
import { setTagType } from "@/utils/index";
const date = new Date();
const currentDate = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
export default defineComponent({
  name: "Leave",
  setup() {
    const router = useRouter();
    ;
    const queryParams = {
      pageNum: 1,
      pageSize: 20,
      leaveDate: undefined
    };
    let list = ref([]);
    let total;
    // type bool : 是否需要拼接数据
    const getList = async type => {
      showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      try {
        const {
          code,
          rows,
          total: sum
        } = await getLeaveList(queryParams);
        if (code === 200) {
          list.value = !type ? rows : list.value.concat(rows);
          total = sum;
        }
        closeToast();
      } catch (error) {
        closeToast();
      }
    };
    // 下拉刷新
    const refreshing = ref(false); // 下拉刷新loading
    const onRefresh = async () => {
      console.log("onRefresh");
      queryParams.pageNum = 1;
      await getList(false);
      finished.value = false;
      refreshing.value = false;
    };
    // 上拉加载
    const loading = ref(false); // 上拉加载loading
    const finished = ref(false); // 是否已经加载完成
    const onLoad = async () => {
      // 查询条数 * 查询页码 >= 总条数
      if (queryParams.pageNum * queryParams.pageSize >= total) {
        finished.value = true;
        loading.value = false;
        return;
      }
      queryParams.pageNum = ++queryParams.pageNum;
      await getList(true);
      loading.value = false;
    };
    onRefresh();
    // 日期组件数据格式化显示
    const formatter = (type, option) => {
      if (type === "year") {
        option.text += "年";
      }
      if (type === "month") {
        option.text += "月";
      }
      if (type === "day") {
        option.text += "日";
      }
      return option;
    };
    const searchDate = ref(currentDate);
    const showPicker = ref(false);
    // 日期确认按钮操作
    const onConfirm = () => {
      queryParams.leaveDate = searchDate.value.join("-");
      showPicker.value = false;
      getList();
    };
    const dteCancel = () => {
      queryParams.leaveDate = undefined;
      showPicker.value = false;
      getList();
    };
    // 跳转到预约添加页
    const toVisitorAdd = () => {
      router.push("/leave/add");
    };
    // 状态
    return {
      router,
      toVisitorAdd,
      searchDate,
      queryParams,
      formatter,
      showPicker,
      onConfirm,
      dteCancel,
      list,
      refreshing,
      onRefresh,
      loading,
      finished,
      onLoad,
      setTagType
    };
  }
});